import Invitation from '@/api/invitation'
import loading from '../helpers/loading'

export default {
  namespaced: true,
  state: {
    ...loading.state
  },
  getters: {
    ...loading.getters
  },
  mutations: {
    ...loading.mutations
  },
  actions: {
    accept: ({ commit, dispatch }, { token, password, passwordConfirmation, platformToken }) => {
      commit('changeLoading', { isLoading: true })
      return Invitation.accept({ token, password, passwordConfirmation, platformToken })
        .then(({ data }) => {
          return Promise.all([
            dispatch('skiliko/session/currentUser', {}, { root: true }),
            dispatch('skiliko/session/currentPlatform', { token: data }, { root: true })
          ])
            .then(_ => {
              commit('skiliko/session/loginEnd', data, { root: true })
              commit('changeLoading', { isLoading: false })
            })
        })
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/invitations/index.js